export{colorPalette,mainColor}from"./colors/index.js";export{Box}from"./Layouts/Box/index.js";export{default as Grid}from"./Layouts/Grid/index.js";export{default as Section}from"./Layouts/Section/index.js";
//# sourceMappingURL=index.js.map
